<template>
    <div>
        <div>
            <div class="grid gap-8 grid-cols-1 lg:p-0 md:gap-6 lg:grid-cols-12">
                <div v-show="!isLoading" class="flex flex-col w-full col-span-full lg:col-span-7 lg:w-[calc(100%+24px)]">
                    <template v-for="(field, i) in CalculatorController.getFieldsList()">
                        <component
                            :key="`component-field-${i}`"
                            :name="field.getComponentName()"
                            :is="field.getComponentName()"
                            :field="field"
                            :position="i"
                            :total="CalculatorController.getFieldsList().length"
                            :showMinPrice="CalculatorController.showMinPrice()"
                            :fieldDisplayPrice="getFieldPrice(field)"
                            :selected="field.selectedOption"
                            :sizes="CalculatorController.getMirrorsSizeField()"
                            :isCircleSelected="CalculatorController.isCircleSelected()"
                            :disabled="CalculatorController.isFieldDisabled(field)"
                            :conditionController="ConditionController"
                            :fieldUpdated="update"
                            :class="{'last-item': i === CalculatorController.getFieldsList().length - 1}"
                        ></component>
                    </template>
                </div>
                
                <div v-if="isLoading" class="relative col-span-full md:col-start-1 md:col-span-7">
                    <div class="lds-ring absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                
                <OrderSummary
                    :calculator-controller="CalculatorController"
                    :add-to-cart="addToCart"
                    :product-added="addedToCart"
                    :update-quantity="updateQuantity"
                    :enable-button="enableButton"
                    :is-error-on-validate="isErrorOnValidate"
                    :processing-form="processingForm"
                    :quantity="quantity"
                    :validation-message="validationMessage"
                    :gallery="gallery"
                    :product-type="productName"
                />
            </div>

            <Alert :show="addedToCart" status="success" class="mt-3 md:mt-6 mlg:mt-10">Your mirror was succesfully added to your cart. <a href="/basket" class="font-bold underline decoration-1 underline-offset-2">Go to my cart</a>!</Alert>
        </div>

        <div v-show="CalculatorController.getSelectedFields().length > 0" class="fixed bg-blue-20 left-0 bottom-0 w-full z-30 | lg:hidden">

            <div class="flex justify-between px-5 pt-4 pb-5 md:px-10">
                <div class="flex flex-col">
                    <div class="text-4 text-4--semibold !text-darkblue-800"> Total:</div>
                    <div class="text-4 text-4--bold"> £{{ CalculatorController.getTotalPrice() }}</div>
                    <div
                        class="link link--small flex justify-center items-center cursor-pointer mt-1"
                        @click="mobileDetails = true"
                    >
                        <icon-eye class=""/>
                        <span class="underline underline-offset-2 decoration-1">See details</span>
                    </div>
                </div>
                
                <div class="self-center">
                    <AddToCartButton
                        :add-to-cart="addToCart"
                        :enable-button="enableButton"
                        :processing-form="processingForm"
                        class="h-14"
                    />
                </div>
            </div>

            <MountingPortal append mountTo="#configurator-field-menu" multiple>
                <OrderSummaryPopup
                    :show="mobileDetails" @close="mobileDetails = false"
                    title="Quote Builder Summary"
                    :background="`bg-blue-20`"
                >
                    <div class="flex flex-col items-stretch overflow-y-auto h-[calc(100%-140px)]">
                        <OrderSummary
                            :calculator-controller="CalculatorController"
                            :add-to-cart="addToCart"
                            :enable-button="enableButton"
                            :is-error-on-validate="isErrorOnValidate"
                            :processing-form="processingForm"
                            :quantity="quantity"
                            :update-quantity="updateQuantity"
                            :validation-message="validationMessage"
                            :forceDisplay="true"
                            :showAddToCart="false"
                            :product-type="productName"
                        />
                    </div>

                    <AddToCartButton
                        :add-to-cart="addToCart"
                        :enable-button="enableButton"
                        :processing-form="processingForm"
                        class="w-full btn--big"
                    />
                </OrderSummaryPopup>
            </MountingPortal>
        </div>
    </div>

</template>

<script>
import FormCalculatorController from "../_controllers/FormCalculatorController";
import VisibilityConditionController from "../_controllers/FieldConditions/VisibilityConditionController";
import ProductPrice from "./components/ProductPrice";
import ProductFields from "./components/fieldType/ProductField";
import ProductFieldPageChange from "./components/fieldType/ProductFieldPageChange";
import FieldSize from "./components/fieldType/FieldSize";
import ProductFieldAddComment from "./components/fieldType/ProductFieldAddComment";
import Comment from "./components/fieldType/Comment";
import PriceCalculator from "../_controllers/PriceCalculator";
import ConditionPriceCalculator from "../_controllers/ConditionPriceCalculator";
import IconRadio from "./components/Icons/IconRadio";
import OrderSummary from "./components/OrderSummary";
import IconEye from "./components/Icons/IconEye";
import AddToCartButton from "./components/helpers/AddToCartButton";
import MobileSelect from "./components/MobileSelect";
import OrderSummaryPopup from "./components/OrderSummaryPopup.vue";
import Alert from "./components/Alert.vue";


const CalculatorController = new FormCalculatorController();
const ConditionController = new VisibilityConditionController(CalculatorController);
const ConPriceCalculator = new ConditionPriceCalculator();

export default {
    name: 'AdminFieldConfigurator',
    components: {
        Alert,
        OrderSummaryPopup,
        MobileSelect,
        AddToCartButton,
        IconEye,
        IconRadio,
        FieldSize,
        ProductFieldAddComment,
        ProductFields,
        ProductFieldPageChange,
        ProductPrice,
        Comment,
        OrderSummary
    },
    props: {
        id: {},
        productFields: {},
        productSku: '',
        productName: '',
        gallery: {},
    },
    data() {
        return {
            CalculatorController: CalculatorController,
            ConditionController: ConditionController,
            ConPriceCalculator: ConPriceCalculator,
            selectedFieldsCount: CalculatorController.getSelectedFields().length,
            validationMessage: null,
            isErrorOnValidate: false,
            processingForm: false,
            quantity: 1,
            show: false,
            mobileDetails: false,
            addedToCart: false
        }
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.watchLeavePage, { capture: true })
    },
    watch: {
        quantity(newValue) {
            if (newValue === '') {
                return;
            }
            CalculatorController.setQuantity(Number(newValue))

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())
        }
    },
    mounted() {
        CalculatorController.setId(this.id)
        CalculatorController.setMirrorOrGlassSizeField()
        CalculatorController.setFieldsList(this.productFields)
    },
    computed: {
        enableButton() {
            return !CalculatorController.allFieldsSelected();
        },
        isLoading() {
            return this.$store.getters.isLoading;
        },
    },
    methods: {
        async addToCart() {
            this.processingForm = true;
            if (CalculatorController.productValid()) {
                await CalculatorController.addItemToCart();

                /**
                 * WooCommerce force refresh fragments
                 */
                $(document.body).trigger('wc_fragment_refresh');

                // TODO: add popup with configuration added product to cart
                this.validationMessage = 'Thank you for shopping, your product has been added to the cart.';
                this.isErrorOnValidate = false;
                this.addedToCart = true;

                this.triggerGaEvent();

                this.clearForm()
            } else {
                // TODO: add popup with errors
                const validationErrors = CalculatorController.getErrors();

                this.validationMessage = validationErrors[0];
                this.isErrorOnValidate = true;
                this.addedToCart = false;
            }
            this.processingForm = false
        },
        updateQuantity(quantity) {
            this.quantity = quantity;
        },
        triggerGaEvent() {

            try {
                const trackObject = {
                    currency: "GBP",
                    value: this.CalculatorController.getTotalPrice(),
                    items: [
                        {
                            item_id: this.productSku,
                            item_name: this.productName,
                            price: this.CalculatorController.getTotalPrice(),
                            quantity: 1
                        }
                    ]
                }


                gtag("event", "add_to_cart", trackObject);
            } catch (e) {

            }

        },
        getFieldPrice(field) {
            if (field.selectedOption) {
                const fieldPrice = ConPriceCalculator.getPriceFromSelectedOption(field.selectedOption)
                const priceCalculatorObj = new PriceCalculator(CalculatorController.getMirrorsSizeField())

                const priceFinal = priceCalculatorObj.getPriceBySize(fieldPrice, field.selectedOption.min_price, field.selectedOption.type);

                return PriceCalculator.roundUp(priceFinal, 2).toFixed(2);
            }

            return 0;
        },
        update() {
            CalculatorController.setMirrorOrGlassSizeField()
            CalculatorController.checkAllFieldVisibilityCondition()

            if (CalculatorController.checkIsSizeIsNotOverMax()) {
                CalculatorController.clearSize();
                // alert('Product size can`t be larger that 4m2.');
            }

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())
            this.watchChangesOnConfigurator()

        },
        clearForm() {
            $(document.body).trigger('wc_fragment_refresh');

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())

            CalculatorController.setFieldsList(this.productFields);
            CalculatorController.setMirrorOrGlassSizeField()
            CalculatorController.clearErrors()
            this.watchChangesOnConfigurator()
        },
        watchChangesOnConfigurator() {
            // if (CalculatorController.anyFieldSelected()) {
            //     window.addEventListener('beforeunload', this.watchLeavePage, { capture: true });
            //
            // } else {
            //     window.removeEventListener('beforeunload', this.watchLeavePage, { capture: true })
            // }
        },
        watchLeavePage(event) {
            event.preventDefault()

            event.returnValue = "Are you sure you want to exit?";

            return event.returnValue = "Your message here"
        }
    },

}
</script>

<style scoped>
.lds-ring {
    @apply inline-block relative;
    width: 80px;
    height: 80px;
}
.lds-ring div {
    @apply block absolute rounded-full m-2;
    box-sizing: border-box;
    width: 64px;
    height: 64px;
    border: 8px solid #6098D5;
    border-color: #6098D5 transparent transparent transparent;
}
.lds-ring div {
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>